/** Nature des opérations — art. 242 nonies A. */

export type OpKind = "good" | "service";
export type OpNature = "BIENS" | "SERVICES" | "MIXTE";

export function opKindOf(raw: unknown, fallback: OpKind = "service"): OpKind {
  const v = String(raw ?? "").trim().toLowerCase();
  if (v === "good" || v === "goods" || v === "bien" || v === "biens") return "good";
  if (v === "service" || v === "services") return "service";
  return fallback;
}

export function opKindLabel(kind: unknown): string {
  return opKindOf(kind) === "good" ? "Biens" : "Services";
}

export function opNatureOf(lines: { label?: string; op_kind?: string | null }[]): OpNature {
  let goods = false;
  let services = false;
  for (const line of lines) {
    if (!(line.label || "").trim()) continue;
    if (opKindOf(line.op_kind) === "good") goods = true;
    else services = true;
  }
  if (goods && services) return "MIXTE";
  if (goods) return "BIENS";
  return "SERVICES";
}

export function opNatureLabel(code: string): string {
  if (code === "BIENS") return "Livraisons de biens";
  if (code === "MIXTE") return "Livraisons de biens et prestations de services";
  return "Prestations de services";
}

export function opNaturePrint(code: string): string {
  const c = (code || "SERVICES").toUpperCase();
  return `Nature des opérations : ${c}`;
}
